/** @format */

import React, { useEffect, useState, useRef } from "react";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import Loader from "../../Components/Loader";
import AdditonalChargesService from "../../Services/AdditionalChargesService";
import SimpleReactValidator from "simple-react-validator";
import { useLocation } from 'react-router-dom'
import CheckAccess from "../../Function/CheckAccess";

export const CourierAdditionalCharges = () => {
  const [, setForceUpdate] = useState("");
  const validator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: setForceUpdate },
    })
  );

  const [loader, setLoader] = useState(true);
  const [fedexList, setFedexList] = useState();
  const [tab, setTab] = useState("Fedex");
  const [peakForm, setPeakForm] = useState({ country: "", per_kg: "", minimum: "" });
  const [peakSearch, setPeakSearch] = useState("");
  const [ups, setUps] = useState();

  const history = useHistory();
  const location = useLocation()
  let user_type = localStorage.getItem("user_type")

  useEffect(() => {
    getItemList();
  }, []);

  const getItemList = () => {
    AdditonalChargesService.getCourieraddionalcharges().then((res) => {
      if (res.status) {
        setLoader(false);
        setFedexList(res.data);
      } else {
        setLoader(false);
      }
    });
  };

  const onchangeArray = (event, key) => {
    let { name, value } = event.target;

    let newArry = [...fedexList];
    
    newArry[key][name] = value

    // newArry.map((val, ind) => {
    //   for (const id in val) {
    //     if (Object.hasOwnProperty.call(val, id)) {
    //       if (ind === key) {
    //         if (name === id) {
    //           val[id] = value;
    //         }
    //       }
    //     }
    //   }
    // });
    setFedexList(newArry);
  };
  const submitHandler = (key, listdata) => {
    console.log('dfgf')
    var check_value = [];
    if (key === "Fedex") {
      check_value = ["vendor_type", "fuel_charges", "govt_tax"];
      var validate =
        validator.current.fieldValid(key + " fuel charges") &&
        validator.current.fieldValid(key + " Govt. tax");
    } else if (key === "Ups") {
      check_value = ["vendor_type", "fuel_charges", "govt_tax"];
      validate =
        validator.current.fieldValid(key + " fuel charges") &&
        validator.current.fieldValid(key + " Govt. tax");
    } else if (key === "Tnt") {
      check_value = ["vendor_type", "fuel_charges", "haldling_in_out", "pallet_charges"];
      validate =
      validator.current.fieldValid(key + " fuel charges") &&
      validator.current.fieldValid(key + " handling in/out") &&
      validator.current.fieldValid(key + " pallet charges");
    }else if (key === "Dhl") {
      check_value = ["vendor_type", "fuel_charges", "govt_tax"];
      validate =
      validator.current.fieldValid(key + " fuel charges") &&
      validator.current.fieldValid(key + " Govt. tax");
    }

    var postData = { id: listdata["_id"] };
    check_value.forEach(function (e) {
      postData[e] = listdata[e];
    });
    postData.peak_countries = Array.isArray(listdata.peak_countries) ? listdata.peak_countries : [];
    postData.peak_start = listdata.peak_start || "";
    postData.peak_end = listdata.peak_end || "";

    if (validate) {
      AdditonalChargesService.updateCourieraddionalcharges(postData).then(
        (res) => {
          if (res.status) {
            history.push("/courier-additional-charges");
            toast.success("Additional charges updated successfully");
          } else {
            toast.error(res.message);
          }
        }
      );
    } else {
      validator.current.showMessages();
    }
  };

  const setField = (key, name, value) => {
    const next = [...fedexList];
    next[key][name] = value;
    setFedexList(next);
  };

  const mergeCountries = (current, incoming) => {
    const map = new Map();
    (current || []).forEach((row) => {
      const name = String(row.country || "").trim().toLowerCase();
      if (name) map.set(name, { country: String(row.country).trim(), per_kg: Number(row.per_kg) || 0, minimum: Number(row.minimum) || 0 });
    });
    incoming.forEach((row) => {
      const name = String(row.country || "").trim().toLowerCase();
      if (!name) return;
      map.set(name, { country: String(row.country).trim(), per_kg: Number(row.per_kg) || 0, minimum: Number(row.minimum) || 0 });
    });
    return Array.from(map.values());
  };

  const readPeakFile = (event, key, current) => {
    const file = event.target.files && event.target.files[0];
    event.target.value = "";
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => {
      AdditonalChargesService.parsePeakFile({ file: reader.result }).then((res) => {
        if (res.status && Array.isArray(res.data) && res.data.length) {
          setField(key, "peak_countries", mergeCountries(current, res.data));
          toast.success(res.data.length + " countries loaded. Click Update to save.");
        } else {
          toast.error(res.message || "No countries found in this file");
        }
      });
    };
    reader.readAsDataURL(file);
  };

  const addPeakCountry = (event, key, current) => {
    event.preventDefault();
    const country = peakForm.country.trim();
    if (!country) {
      toast.error("Enter a country");
      return;
    }
    setField(key, "peak_countries", mergeCountries(current, [{
      country,
      per_kg: peakForm.per_kg,
      minimum: peakForm.minimum,
    }]));
    setPeakForm({ country: "", per_kg: "", minimum: "" });
    toast.success("Country added. Click Update to save.");
  };

  const removePeakCountry = (key, current, country) => {
    const name = String(country || "").trim().toLowerCase();
    setField(key, "peak_countries", (current || []).filter((row) => String(row.country || "").trim().toLowerCase() !== name));
  };

  const downloadSample = (vendor) => {
    const link = document.createElement("a");
    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent("Country,Demand/Peak Surcharge per kg,Minimum\n");
    link.download = vendor + "-peak-surcharge-sample.csv";
    link.click();
  };

  const downloadPeakList = (vendor, rows) => {
    const lines = ["Country,Demand/Peak Surcharge per kg,Minimum"];
    rows.forEach((row) => lines.push(`${row.country},${row.per_kg},${row.minimum}`));
    const link = document.createElement("a");
    link.href = "data:text/csv;charset=utf-8," + encodeURIComponent(lines.join("\n"));
    link.download = vendor + "-peak-surcharge.csv";
    link.click();
  };

  const tabs = [
    { id: "Fedex", label: "FedEx" },
    { id: "Ups", label: "UPS" },
    { id: "Dhl", label: "DHL" },
    { id: "Tnt", label: "Land" },
  ];

  return (
    <>
      <div class="d-flex justify-content-end mb-3">
        {/* <button
          class="btn btn-primary w-sm waves-effect waves-light"
          onClick={() => history.push("add-courier-additonal-charges")}
        >
          Add Additional Charges
        </button> */}
      </div>
      <div className="d-flex flex-wrap mb-3" style={{ gap: 8 }}>
        {tabs.map((item) => (
          <button
            key={item.id}
            type="button"
            className={tab === item.id ? "btn btn-primary" : "btn btn-outline-primary"}
            onClick={() => setTab(item.id)}
          >
            {item.label}
          </button>
        ))}
      </div>
      <div className="row">
        {fedexList &&
          fedexList.map((item, key) => {
            if (item.vendor_type !== tab) return null;
            const rows = Array.isArray(item.peak_countries) ? item.peak_countries : [];
            return (
              <div className="col-lg-12">
                <div className="card">
                  <div class="d-flex mb-3 align-items-center card-header">
                    <h5 class="mb-0 me-auto">
                      Additional Charges{" "}
                      <b>
                        <small className="text-muted">
                          ({item.vendor_type=="Tnt"?'Land Mode':item.vendor_type})
                        </small>
                      </b>
                    </h5>
                  </div>
                  <div className="card-body">
                  <h5>{item.vendor_type==="Tnt" && "Land Consolidation"}</h5>
                  <hr className="mt-1 mb-4" style={{display: item.vendor_type==="Tnt" ? 'block' : 'none'}} />

                    {(item.vendor_type == "Ups" ||
                      item.vendor_type == "Fedex" ||
                      item.vendor_type == "Tnt" || 
                      item.vendor_type == "Dhl") && (
                      <>
                        <div className="row">
                          <div className="col-6">
                            <label>Vendor Type</label>
                          </div>
                          <div className="col-6">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Enter Fuel Charges"
                              value={item.vendor_type}
                              readOnly
                            />
                          </div>
                        </div>
                      </>
                    )}

                    {(item.vendor_type == "Ups" ||
                      item.vendor_type == "Fedex" ||
                      item.vendor_type == "Tnt" ||
                      item.vendor_type == "Dhl") && (
                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>
                              Fuel charges <small className="muted">%</small>
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Fuel Charges"
                              value={item.fuel_charges}
                              name="fuel_charges"
                              onChange={(e) => onchangeArray(e, key)}
                              onWheel={(e) => e.target.blur()}
                            />
                            {validator.current.message(
                              item.vendor_type + " fuel charges",
                              item.fuel_charges,
                              "required",
                              { className: "text-danger text-capitalize" }
                            )}
                          </div>
                        </div>
                      </>
                    )}

                    {(item.vendor_type == "Ups" ||
                      item.vendor_type == "Fedex"||
                      item.vendor_type == "Dhl") && (
                      <>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>
                              Government Tax <small className="muted">%</small>
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Government Tax"
                              value={item.govt_tax}
                              name="govt_tax"
                              onChange={(e) => onchangeArray(e, key)}
                              onWheel={(e) => e.target.blur()}
                            />
                            {validator.current.message(
                              item.vendor_type + " Govt. tax",
                              item.govt_tax,
                              "required",
                              { className: "text-danger text-capitalize" }
                            )}
                          </div>
                        </div>
                      </>
                    )}

                    {item.vendor_type == "Tnt" && ( <>
                         <h5 className="mt-4">Land Express</h5> 
                      {/* <div className="card-header mt-2"> */}
                        {/* <label className="text-muted mb-0">Destination cross border charges :-</label> */}
                        <hr className="mt-1" />
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>
                              Handling In/Out
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={
                                item.haldling_in_out
                              }
                              name="haldling_in_out"
                              onChange={(e) => onchangeArray(e, key)}
                              onWheel={(e) => e.target.blur()}
                            />
                            {validator.current.message(
                              item.vendor_type + " handling in/out",
                              item.haldling_in_out,
                              "required",
                              { className: "text-danger text-capitalize" }
                            )}
                          </div>
                        </div>
                        <div className="row mt-3">
                          <div className="col-6">
                            <label>
                              Pallet Charges
                            </label>
                          </div>
                          <div className="col-6">
                            <input
                              type="number"
                              className="form-control"
                              placeholder="Enter Charges"
                              value={
                                item.pallet_charges
                              }
                              name="pallet_charges"
                              onChange={(e) => onchangeArray(e, key)}
                              onWheel={(e) => e.target.blur()}
                            />
                            {validator.current.message(
                              item.vendor_type + " pallet charges",
                              item.pallet_charges,
                              "required",
                              { className: "text-danger text-capitalize" }
                            )}
                          </div>
                        </div>
                      {/* </div> */}
                       </>
                    )}

                    <hr className="mt-4" />
                    <h5 className="mb-1">Peak surcharge by country</h5>
                    <p className="mb-3">
                      The charge is per kg, or the minimum, whichever is higher.
                      File columns: <b>Country</b>, <b>Demand/Peak Surcharge per kg</b>, <b>Minimum</b>.
                      Uploading adds new countries and updates countries already in the file. Other saved countries stay.
                    </p>
                    <div className="row mb-3">
                      <div className="col-md-4">
                        <label>Peak start date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={item.peak_start ? String(item.peak_start).slice(0, 10) : ""}
                          onChange={(e) => setField(key, "peak_start", e.target.value)}
                        />
                      </div>
                      <div className="col-md-4">
                        <label>Peak end date</label>
                        <input
                          type="date"
                          className="form-control"
                          value={item.peak_end ? String(item.peak_end).slice(0, 10) : ""}
                          onChange={(e) => setField(key, "peak_end", e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-wrap justify-content-end mb-3">
                      <button type="button" className="btn btn-outline-secondary mx-1" onClick={() => downloadSample(item.vendor_type)}>Sample CSV</button>
                      <input id={"peak-upload-" + item.vendor_type} type="file" accept=".csv,.xlsx,.xls" hidden onChange={(e) => readPeakFile(e, key, rows)} />
                      <label htmlFor={"peak-upload-" + item.vendor_type} className="btn btn-danger mx-1 mb-0">Upload file</label>
                    </div>
                    <form className="row align-items-end mb-4" onSubmit={(e) => addPeakCountry(e, key, rows)}>
                      <div className="col-md-4 mb-2">
                        <label>Country</label>
                        <input className="form-control" value={peakForm.country} onChange={(e) => setPeakForm({ ...peakForm, country: e.target.value })} placeholder="Country" />
                      </div>
                      <div className="col-md-3 mb-2">
                        <label>Demand/Peak Surcharge per kg</label>
                        <input className="form-control" value={peakForm.per_kg} onChange={(e) => setPeakForm({ ...peakForm, per_kg: e.target.value })} placeholder="Per kg" />
                      </div>
                      <div className="col-md-3 mb-2">
                        <label>Minimum (AED)</label>
                        <input className="form-control" value={peakForm.minimum} onChange={(e) => setPeakForm({ ...peakForm, minimum: e.target.value })} placeholder="Minimum" />
                      </div>
                      <div className="col-md-2 mb-2">
                        <button type="submit" className="btn btn-primary w-100">Save</button>
                      </div>
                    </form>
                    <div className="d-flex flex-wrap align-items-center mb-3">
                      <input
                        className="form-control"
                        style={{ maxWidth: 320 }}
                        value={peakSearch}
                        onChange={(e) => setPeakSearch(e.target.value)}
                        placeholder="Search"
                      />
                      <button type="button" className="btn btn-success mx-2" onClick={() => downloadPeakList(item.vendor_type, rows)} disabled={!rows.length}>Download list</button>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-centered table-nowrap mb-0 border text-center">
                        <thead className="table-light">
                          <tr>
                            <th>Country</th>
                            <th>Demand/Peak Surcharge per kg</th>
                            <th>Minimum (AED)</th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody>
                          {rows.filter((row) => String(row.country || "").toLowerCase().includes(peakSearch.trim().toLowerCase())).length ? rows.filter((row) => String(row.country || "").toLowerCase().includes(peakSearch.trim().toLowerCase())).map((row) => (
                            <tr key={row.country}>
                              <td>{row.country}</td>
                              <td>{row.per_kg}</td>
                              <td>{row.minimum}</td>
                              <td>
                                <button type="button" className="btn btn-sm btn-outline-danger" onClick={() => removePeakCountry(key, rows, row.country)}>Remove</button>
                              </td>
                            </tr>
                          )) : (
                            <tr>
                              <td colSpan="4">{rows.length ? "No matching country." : "No countries yet. Upload the CSV or add one country."}</td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    {
                       (CheckAccess(215,"edit") || user_type === "SUPERADMIN") && 
                    <button
                      class="btn btn-primary ms-auto d-block mt-3"
                      onClick={() => submitHandler(item.vendor_type, item)}
                    >
                      Update{" "}
                    </button>
                    }

                  </div>
                </div>
              </div>
            );
          })}
        <Loader isShow={loader} />
      </div>
    </>
  );
};
